import React from 'react';
import PropTypes from 'prop-types';

import { Button, Stack } from '@mui/material';
import { spacing } from '@loggi/front-design-tokens';

export default function PrimaryAction({ title, onClick }) {
  return (
    <Stack p={spacing.stack.xxsmall}>
      <Button
        variant="contained"
        onClick={onClick}
        data-testid="footer-primary-action-btn"
      >
        {title}
      </Button>
    </Stack>
  );
}

PrimaryAction.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};
